import { Point } from './generalTypes';

const zip = <A, B>(a: A[], b: B[]): [A, B][] =>
  Array.from(Array(Math.min(b.length, a.length)), (_, i) => [a[i], b[i]]);
export const zipWithNext = <T extends any>(arr: T[]): [T, T][] =>
  zip(arr, arr.slice(1));

export function commaStringToPoint(s: string): Point {
  const [a, b] = s.split(',');
  const x = parseFloat(a);
  const y = parseFloat(b);
  if (x > y) {
    return { lat: x, lon: y };
  } else {
    return { lat: y, lon: x };
  }
}

export function nonEmptyLines(s: string): string[] {
  return s
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.length > 0);
}
